module dg.objects {
    import DG_DATA_TYPES = dg.restfulApi.DG_DATA_TYPES;

    export class AmountDisplayerController extends PropertyDisplayerControllerBase<number> {
        public constructor(
            private $filter: ng.IFilterService
        ) {
            super();
        }

        public unit: string;
        public numberFormat: any;
        public formattedValue: string;
        public precision: any;

        $onChanges = () => {

            if (this.value || this.value == 0) {
                this.formattedValue =  this.value.toString();

                if (this.numberFormat) {
                    this.formattedValue = this.$filter('number')(this.value, this.numberFormat);
                }

                if (this.unit) {
                    this.formattedValue += this.unit;
                } 

                if (!this.precision) {
                    this.precision = 0;
                }

            }
            else {
                this.formattedValue = '';
            }
        }
    }

    dg.objects.AngularHelper.registerPropertyDisplayer(AmountDisplayerController, 'amountDisplayer', {
        bindings: {
            unit: '@?',
            numberFormat: '@?',
            precision: '<'
        },
        template: '<span ng-bind="($ctrl.formattedValue | number : $ctrl.precision)"></span>'
    });
}
